import { render, staticRenderFns } from "./ModalRule.vue?vue&type=template&id=cc6d2162&scoped=true"
import script from "./ModalRule.vue?vue&type=script&lang=js"
export * from "./ModalRule.vue?vue&type=script&lang=js"
import style0 from "./ModalRule.vue?vue&type=style&index=0&id=cc6d2162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6d2162",
  null
  
)

export default component.exports